import {Component, Input} from '@angular/core';
import {LoadingSpinnerComponent} from '../loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss'],
  imports: [LoadingSpinnerComponent],
  standalone: true
})
export class LoadingOverlayComponent {
  @Input() loading: boolean = false;
}
